import React, { useRef, useEffect } from "react";
import "../css/insurancewithinvestment.css";
import investmentwithinsuranceimg from "../assets/investmentwithinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const InsuranceWithInvestment = () => {
    const API_URL = process.env.REACT_APP_Dashboard_API_URL;
    const imageRefs = useRef([]);
    const imageSources = [
        investmentwithinsuranceimg,
        tollfreenumberimg
    ];

    useEffect(() => {
        if (imageRefs.current.length > 0) {
            let index = 0;
            const showNextImage = () => {
                imageRefs.current.forEach((img, i) => {
                    if (img) img.style.display = i === index ? "block" : "none";
                });
                index++;
                if (index >= imageRefs.current.length) index = 0;
                setTimeout(showNextImage, 3000);
            };
            showNextImage();
        }
    }, []);

    const handleSubmit = async (data) => {
        const inquriyData = new FormData();
        inquriyData.append("Name", data.Name);
        inquriyData.append("Email", data.Email);
        inquriyData.append("PreferredDate", data.Date);
        inquriyData.append("PreferredTime", data.Time);
        inquriyData.append("MobileNo", data.MobileNo);
        inquriyData.append("Status", "New");
        inquriyData.append("UserId", data.Id);
        inquriyData.append("InquiryType", "Insurance Inquiries");
        inquriyData.append("PolicyType", "Insurance With Investment");
        inquriyData.append("IsLoggedIn", data.isLoggedIn);
        inquriyData.append("Otp", data.OTP);

        try {
            const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return { status: response.status, data: response.data };
        } catch (error) {
            return {
                status: 500,
                data: { success: false, message: error.response?.data?.message }
            };
        }
    };

    return (
        <div className="investmentinsurance-container">
            <Helmet>
                <title>Insurance with Investment Advice | Grow & Protect Wealth</title>
                <meta name="description" content="Combine insurance and investment smartly. Get expert advice to build wealth while protecting your future with the right policies." />
                <link rel="canonical" href="https://policysamjho.com/insurance-with-investment-advice/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Insurance with Investment Advice",
                        "description": "Learn how to combine insurance and investment for long-term benefits. Get expert advice to grow wealth and secure your future with Policy Samjho.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com/"
                        },
                        "serviceType": "Insurance and Investment Consultation",
                        "areaServed": "IN",
                        "url": "https://policysamjho.com/insurance-with-investment-advice/",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-9584484800",
                            "email": "info@policysamjho.com",
                            "contactType": "customer service"
                        }
                    })}
                </script>
            </Helmet>

            <div className="investmentinsurance-hero-container">
                <div className="investmentinsurance-hero-text-box">
                    <h1>
                        <span style={{ color: '#192437' }}>Insurance with </span>
                        <span style={{ color: '#F5A526' }}>Investment Advice</span>
                    </h1>
                    <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
                        Grow your wealth while securing your family's financial future with our investment-linked insurance plans.
                    </p>
                </div>
                <div className="investmentinsurance-hero-image-box investmentinsurance-imgslider">
                    {imageSources.map((image, index) => (
                        <img
                            key={index}
                            ref={(el) => (imageRefs.current[index] = el)}
                            src={image}
                            className="investmentinsurance-sliderimg"
                            alt={`insurancewithinvestment-slide-${index}`}
                            style={{ display: index === 0 ? "block" : "none" }}
                        />
                    ))}
                </div>
            </div>

            <div className="investmentinsurance-containform-container">
                <div className="col-md-6 investmentinsurance-info">
                    <h2 className="investmentinsurance-heading">
                        <span style={{ color: '#192437' }}>What is </span>
                        <span style={{ color: '#F5A526' }}>Investment Insurance?</span>
                    </h2>
                    <p className="investmentinsurance-text">
                        Investment insurance combines the benefits of wealth creation and protection, allowing you to invest while ensuring financial security for your loved ones.
                    </p>

                    <h2 className="investmentinsurance-subheading">
                        <span style={{ color: '#192437' }}>Why is Investment </span>
                        <span style={{ color: '#F5A526' }}>Insurance Important?</span>
                    </h2>
                    <ul className="investmentinsurance-benefits">
                        <li className="investmentpoints">Flexible investment options</li>
                        <li className="investmentpoints">Growth of wealth over time</li>
                        <li className="investmentpoints">Long-term financial security</li>
                        <li className="investmentpoints">Protection against unforeseen risks</li>
                    </ul>

                    <h2 className="investmentinsurance-subheading">
                        <span style={{ color: '#192437' }}>Comprehensive Coverage & </span>
                        <span style={{ color: '#F5A526' }}>Investment Benefits</span>
                    </h2>
                    <p className="investmentinsurance-text spaced-text">
                        Investment insurance ensures a steady financial future by combining investment growth with life coverage. It helps you achieve your financial goals while providing security against unexpected events.
                    </p>
                </div>

                <div>
                    <h4 className="consultationform-heading">
                        <span style={{ color: "#192437" }}>Get a Free </span>
                        <span style={{ color: "#F5A526" }}> Investment Consultation </span>
                    </h4>
                    <ConsultationForm onSubmit={handleSubmit} />
                </div>
            </div>

            <PoliciesSlider category="Insurance With Investment" />
            <ChatbotAi />
        </div>
    );
};

export default InsuranceWithInvestment;